import type { ApiEnvelope } from '@/types/api.types';
import { apiClient } from '@lib/axios';

import type {
  Closure,
  ClosuresList,
  CreateClosureRequest,
  PatchClosureRequest,
} from '../types';

export async function getClosures(accountId: string): Promise<ClosuresList> {
  const { data } = await apiClient.get<ApiEnvelope<Closure[]>>(
    `/settings/accounts/${accountId}/closures`,
  );
  return { closures: data.data };
}

export async function createClosure(
  accountId: string,
  body: CreateClosureRequest,
): Promise<Closure> {
  const { data } = await apiClient.post<ApiEnvelope<Closure>>(
    `/settings/accounts/${accountId}/closures`,
    body,
  );
  return data.data;
}

export async function patchClosure(
  accountId: string,
  closureId: string,
  body: PatchClosureRequest,
): Promise<Closure> {
  const { data } = await apiClient.patch<ApiEnvelope<Closure>>(
    `/settings/accounts/${accountId}/closures/${closureId}`,
    body,
  );
  return data.data;
}

export async function deleteClosure(
  accountId: string,
  closureId: string,
): Promise<void> {
  await apiClient.delete(`/settings/accounts/${accountId}/closures/${closureId}`);
}
